/**
 * {@docCategory GroupedList}
 */
export var CollapseAllVisibility;
(function (CollapseAllVisibility) {
  CollapseAllVisibility[CollapseAllVisibility["hidden"] = 0] = "hidden";
  CollapseAllVisibility[CollapseAllVisibility["visible"] = 1] = "visible";
})(CollapseAllVisibility || (CollapseAllVisibility = {}));